/* Publish by EComposer at 2025-08-01 17:31:11*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-a6jyt3ztk0f"]=  window.__ectimmers["ecom-a6jyt3ztk0f"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-a6jyt3ztk0f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a6jyt3ztk0f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5hyxcv2v4pa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5hyxcv2v4pa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sirq7zv8ja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sirq7zv8ja', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mwidjwjuygc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mwidjwjuygc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eneg3tocplc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eneg3tocplc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rn8nqfkzp3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rn8nqfkzp3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nbc3pvrqvma').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nbc3pvrqvma', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cijkig111ro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cijkig111ro', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-38bo4ricsc2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-38bo4ricsc2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qimxsqiyf0d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qimxsqiyf0d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b6kjy9zffu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b6kjy9zffu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4s3jsn7ye2e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4s3jsn7ye2e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ill7518eg6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ill7518eg6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8pt7yh996nu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8pt7yh996nu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a2cnvnlqwhp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a2cnvnlqwhp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oulumegomlr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oulumegomlr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cfxu2ah5d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cfxu2ah5d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-77k9ngxzvpi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-77k9ngxzvpi', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7xm058euu6o"]=  window.__ectimmers["ecom-7xm058euu6o"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-7xm058euu6o"]["cr8jyaa2h"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-7xm058euu6o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7xm058euu6o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vsgr7igw00a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vsgr7igw00a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8y1zcwrh6bb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8y1zcwrh6bb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z9c9pe25nbn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z9c9pe25nbn', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6hv60ywzx92"]=  window.__ectimmers["ecom-6hv60ywzx92"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-6hv60ywzx92').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6hv60ywzx92', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3mar5u7o341').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3mar5u7o341', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9jiglfckqdh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9jiglfckqdh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5m07xyiddxi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5m07xyiddxi', settings: {"link":"lightbox","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x9prikbjhq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x9prikbjhq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xp7mol3vban').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xp7mol3vban', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0natljc3cii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0natljc3cii', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-25ezjg9i02b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-25ezjg9i02b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qmq9zoo7ivf"]=  window.__ectimmers["ecom-qmq9zoo7ivf"] || {};
var e=this.$el;if(e&&this.isLive){var o=e.querySelectorAll(".element-social-link:not(.element-social-link__custom)");o.length&&o.forEach(function(s){var n=s.getAttribute("href")||"#",r=n.replace("{current-link}",location.href);s.setAttribute("href",r)})}

                    });
                    
                        document.querySelectorAll('.ecom-qmq9zoo7ivf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmq9zoo7ivf', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-aw0ovj3nkh"]=  window.__ectimmers["ecom-aw0ovj3nkh"] || {};
if(this.settings.layout==="slider"){let i=this.$el,t="bullets";if(this.settings.slider_pagination_style==="progress"&&(t="progressbar"),!i)return;let o=i.querySelector(".ecom-shopify__blog-container"),s=o&&o.dataset.optionSwiper;s=JSON.parse(s),s.pagination={el:i.querySelector(".ecom-swiper-pagination"),type:t,clickable:!0},s.navigation={nextEl:i.querySelector(".ecom-swiper-button-next"),prevEl:i.querySelector(".ecom-swiper-button-prev")},new window.EComSwiper(o,s)}if(this.settings.use_ajax&&this.isLive){const i=this.$el;if(!i)return;const t=i.querySelector(".ecom-shopify__blog-wrapper"),o=function(e){e.preventDefault();const a=this.dataset.get,n=this.closest(".ecom-sections[data-section-id]");if(!a||!n||!n.dataset.sectionId)return;const p=n.dataset.sectionId,_=`${a}&section_id=${p}`;c(_,n),t.scrollIntoView()};i.querySelectorAll(".ecom-pagination-item").forEach(e=>{e.addEventListener("click",o)});const c=function(e,a){const n=async function(p){return(await fetch(p,{method:"GET",cache:"no-cache",headers:{"Content-Type":"text/html"}})).text()};a.classList.add("ecom-doing-load-blog"),n(e).then(function(p){i.querySelectorAll(".ecom-shopify__blog--post").forEach(function(u){u.remove()});const d=document.createElement("div");d.innerHTML=p;const r=d.querySelector(".ecom-shopify__blog--posts");if(!r)return;const y=a.querySelector(".ecom-shopify__blog--posts"),$=a.querySelector(".ecom-pagination-navigation.ecom-collection__pagination-navigation");for(;r.firstChild;)y.appendChild(r.firstChild);r.parentNode.removeChild(r);const h=d.querySelector(".ecom-pagination-navigation.ecom-collection__pagination-navigation");h&&($.innerHTML=h.innerHTML,i.querySelectorAll(".ecom-pagination-item").forEach(v=>{v.addEventListener("click",o)}))}).finally(function(){a.classList.remove("ecom-doing-load-blog")})}}

                    });
                    
                        document.querySelectorAll('.ecom-aw0ovj3nkh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aw0ovj3nkh', settings: {"layout":"grid"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}